import React from 'react'
import Hero from '../components/banner'

const Start = () => {
    return (
        <div>
           <Hero/>
        </div>
    )
}

export default Start
